<fhm-search-page [gridData]="gridData"
                 [showLink]="true"
                 [showAdd]="!searchMode"
                 [showColumnSearch]="false"
                 [type]="'customer-instance-venue-search'"
                 [showDeleteFunc]="showDelete"
                 [showRecontinueFunc]="showRecontinue"
                 [showRefresh]="true"
                 (refresh)="refresh()"
                 (addNew)="createNew()"
                 (deleteRecord)="deleteVenue($event)"
                 [paging]="true"
                 (recontinueRecord)="recontinueVenue($event)"
                 [styleColumnFn]="styleColumnFn"
                 [valueColumnFn]="valueColumnFn"
                 [columns]="['name', 'clientId', 'deploymentStatus', 'requiresAction', 'discontinued']"
                 (selectRecord)="recordSelected($event)">
    <div class="searchControls">
        <fui-filter-form-context>
            <div class="filter">
                <fui-search-control [(ngModel)]="filterName" class="filter-name"
                                    [label]="'fhm.common.label.search'"
                                    (valueChange)="updateFilter()"
                                    [placeholder]="' '"></fui-search-control>
                <fui-search-control [(ngModel)]="filterClientId" class="filter-clientId"
                                    [label]="'fhm.customer-instance-venue-search.filter.clientId'"
                                    (valueChange)="updateFilter()"
                                    [placeholder]="' '"></fui-search-control>
                <fhm-venue-deployment-status-select-control class="filter-deploymentStatus" (valueChange)="changeDeploymentStatus($event)">
                </fhm-venue-deployment-status-select-control>
                <fui-column>
                    <fui-checkbox-control class="filter-requiresAction"
                                          [(ngModel)]="filterRequiresAction"
                                          (valueChange)="updateFilter()"
                                          [label]="'fhm.customer-instance-venue-search.filter.requiresAction'"></fui-checkbox-control>
                    <fui-checkbox-control class="filter-requiresAction"
                                          [(ngModel)]="showDiscontinued"
                                          (valueChange)="updateFilter()"
                                          [label]="'fhm.customer-instance-venue-search.filter.showDiscontinued'"></fui-checkbox-control>
                </fui-column>
            </div>
        </fui-filter-form-context>
    </div>
</fhm-search-page>
